module.exports = __webpack_public_path__ + "static/app-shot-n-1-2-684a86284a6a6f5af08e566c885cf3df.png";